import { MAP_BOX_ACCESS_TOKEN, MAP_BOX_SEARCH_BASE_URL } from './apiConstant';
import axios from "axios";
import {MapboxResponse, MapboxFeature, AddressSearchResponse} from './mapBoxSearchType';

    export const getAddressSearchResults = async (
    text: string
    ): Promise<AddressSearchResponse> => {
    const url = `${MAP_BOX_SEARCH_BASE_URL}?q=${encodeURIComponent(
        text
    )}&auto_complete=true&access_token=${MAP_BOX_ACCESS_TOKEN}`;

    try {
        // Axios call returning MapboxResponse (features array)
        const res = await axios.get<MapboxResponse>(url);

        const features: MapboxFeature[] = res.data?.features || [];

        // Wrap features in AddressSearchResponse
        const response: AddressSearchResponse = {
        type: "FeatureCollection",
        features,
        };

        return response;

    } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
        if (err.response) {
            console.error("API error response:", err.response.data);
            throw new Error(
            `HTTP ${err.response.status}: ${err.response.statusText}`
            );
        } else if (err.request) {
            console.error("No response received:", err.request);
            throw new Error("No response from server");
        }
        console.error("Axios error:", err.message);
        throw new Error(err.message);
        } else {
        console.error("Unexpected error:", err);
        throw new Error("Unexpected error occurred");
        }
    }
    };